/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{FloatPassUniform as o}from"../../../core/shaderModules/FloatPassUniform.js";import{glsl as a}from"../../../core/shaderModules/glsl.js";function e(e){const t=e.vertex;t.uniforms.add(new o("distanceFalloffFactor",(o=>o.distanceFalloffFactor))),t.code.add(a`float distanceBasedPerspectiveFactor(float distance) {
return clamp(sqrt(distanceFalloffFactor / distance), 0.0, 1.0);
}`)}export{e as DistanceFalloff};
